<template>
    <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="50%"
            :before-close="handleClose">
        <div class="treeBox">
            <el-tree
                    ref="tree"
                    :data="tabDataList"
                    :props="defaultProps"
                    :check-strictly="true"
                    node-key="id"
                    :default-checked-keys="selectTabList"
                    show-checkbox
                    @check="nodeClick">
            </el-tree>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confimBtn">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "tabShow",
        data(){
            return{
                dialogVisible: false,
                tabDataList:[],
                selectTabList: [],

                defaultProps: {
                    children: 'children',
                    label: 'label'
                }
            }
        },
        props:['title'],
        methods:{
            init(){
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    for (let i in this.$refs.tree.store.nodesMap) {
                        this.$refs.tree.store.nodesMap[i].expanded = true;
                    }
                })

            },
            confimBtn(){
                let selectTabList = this.$refs.tree.getCheckedKeys();
                this.$emit('setSelectTabList', selectTabList);
                this.dialogVisible = false;
            },
            nodeClick(currentObj, treeStatus){
                console.log(currentObj)
                console.log("=========")
                console.log(treeStatus)
                // 用于：父子节点严格互不关联时，父节点勾选变化时通知子节点同步变化，实现单向关联。
                let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1未选中,>=0为选中
                // 选中
                if (selected !== -1) {
                    // 子节点只要被选中父节点就被选中(需要选中父节点时候调用此方法)
                    this.selectedParent(currentObj)
                    // 统一处理子节点为相同的勾选状态
                    this.uniteChildSame(currentObj, true)
                } else {
                    // 未选中 处理子节点全部未选中
                    if (currentObj.children&&currentObj.children.length !== 0) {
                        this.uniteChildSame(currentObj, false)
                    }
                    this.isAllNoSelectChildren(currentObj);
                }
            },
            // 统一处理子节点为相同的勾选状态
            uniteChildSame (treeList, isSelected) {
                this.$refs.tree.setChecked(treeList.id, isSelected)
                if(treeList.children){
                    for (let i = 0; i < treeList.children.length; i++) {
                        this.uniteChildSame(treeList.children[i], isSelected)
                    }
                }
            },
            // 统一处理父节点为选中
            selectedParent (currentObj) {
                let currentNode = this.$refs.tree.getNode(currentObj)
                if (currentNode.parent.key !== undefined) {
                    this.$refs.tree.setChecked(currentNode.parent, true)
                    this.selectedParent(currentNode.parent)
                }
            },
            isAllNoSelectChildren(currentObj){
                let currentNode = this.$refs.tree.getNode(currentObj)
                let noSelectIndex =  currentNode.parent.childNodes.findIndex(item => item.checked == true)
                if(noSelectIndex == -1){
                    this.$refs.tree.setChecked(currentNode.parent, false)
                    this.isAllNoSelectChildren(currentNode.parent)
                }
            },
            handleClose(done) {
                this.$confirm('确认关闭？','提示')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            }
        }
    }
</script>

<style scoped>
    /*.treeBox{*/
    /*    display: flex;*/
    /*    justify-content: center;*/
    /*}*/
</style>
